import {App} from "vue";

import PrimeVue, {PrimeVueConfiguration} from 'primevue/config';
import Lara from '@primevue/themes/lara';
import {definePreset} from '@primevue/themes';

import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import Ripple from 'primevue/ripple';
import Badge from 'primevue/badge';

const MyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#f5f4fe',
      100: '#edeafd',
      200: '#ddd8fc',
      300: '#c3b9f9',
      400: '#a691f4',
      500: '#8864ee',
      600: '#723be3',
      700: '#6831d0',
      800: '#5728af',
      900: '#49238f',
      950: '#2c1461'
    }
  }
});

export const applyPrimeVue = (app: App) => {
  app.use(PrimeVue, {
    theme: {
      preset: MyPreset,
      options: {
        darkModeSelector: 'class',
      }
    },
    locale: {
      dayNames: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
      dayNamesShort: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
      dayNamesMin: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
      monthNames: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
      monthNamesShort: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
      today: 'היום',
      weekHeader: 'Wk',
      firstDayOfWeek: 0,
      dateFormat: 'dd.mm.yy',
      fileSizeTypes: []
    },
    pt: {
      button: {
        root: { class: '!rounded-md border' },
        label: {class: '!font-medium'}
      },
      drawer: {
        footer: {style: 'padding: 0.25rem'}
      }
    }
  } satisfies PrimeVueConfiguration);
  app.directive('ripple', Ripple);
  app.component('Badge', Badge);
  app.use(ConfirmationService);
  app.use(DialogService);
}
